<div class="mo-card rp-tw">
  <div class="rp-ts">
    <table class="rp-t">
      <caption class="sr-only">Posts, sorted by {{ sortLabel() }}</caption>
      <thead>
        <tr>
          <th scope="col" class="min-w-[220px]">Post</th>
          <th scope="col" [class.on]="sort() === 'posted'" [attr.aria-sort]="sort() === 'posted' ? 'descending' : null">
            <button type="button" (click)="sortBy.emit('posted')">Posted
              @if (sort() === 'posted') {<mba-icon name="arrow-down" size="size-[13px]" />}
            </button>
          </th>
          @for (col of cols; track col.key) {
          <th scope="col" class="n" [class.on]="sort() === col.key" [class.hot]="hot() === col.key"
            [attr.aria-sort]="sort() === col.key ? 'descending' : null">
            <button type="button" (click)="sortBy.emit(col.key)">{{ col.label }}
              @if (sort() === col.key) {<mba-icon name="arrow-down" size="size-[13px]" />}
            </button>
          </th>
          }
          <th scope="col" class="w-[84px] text-center">Ad Code</th>
          <th scope="col" class="w-[72px]">Source</th>
          <th scope="col" class="chev"><span class="sr-only">Open</span></th>
        </tr>
      </thead>
      <tbody>
        @if (rows().length) {
        <tr class="tot">
          <td><span class="lab">{{ totalsLabel() }}</span></td>
          <td></td>
          @for (col of cols; track col.key) {
          <td class="n" [class.hot]="hot() === col.key">
            @if (statsLoading()) {<span class="rp-sk ml-auto w-12"></span>} @else {{{ total(col.key) }}}
          </td>
          }
          <td></td>
          <td></td>
          <td></td>
        </tr>
        }

        @for (row of rows(); track row.post.id) {
        <tr class="row" [class.cur]="currentId() === row.post.id" tabindex="0" [attr.data-post]="row.post.id"
          [attr.aria-label]="rowLabel(row)" (click)="open.emit(row.post.id)" (keydown)="onRowKey($event, row.post.id)">
          <td>
            <div class="mm-post">
              <span class="mm-mini">
                @if (row.post.thumbnailUrl) {
                <img [src]="row.post.thumbnailUrl" alt="" loading="lazy" class="absolute inset-0 size-full object-cover" />
                }
                <mba-icon name="play" size="size-3.5 relative text-white drop-shadow" />
                @if (row.post.platform) {
                <span class="mo-logo"><img [src]="logos[row.post.platform]" alt="" /></span>
                }
              </span>
              <span class="flex min-w-0 flex-col">
                <b>{{ row.creator?.name ?? 'Creator' }}</b>
                <span class="mo-sub">{{ row.post.deliverableLabel }} · {{ channelName(row.post.socialChannel) }}</span>
              </span>
            </div>
          </td>
          <td>
            <div class="rp-pd">
              <span>{{ posted(row) }}</span>
              @if (statsLoading()) {<span class="rp-sk w-24"></span>} @else {<span class="mo-sub">{{ refreshed(row) }}</span>}
            </div>
          </td>
          @for (col of cols; track col.key) {
          <td class="n" [class.hot]="hot() === col.key">
            @if (statsLoading()) {<span class="rp-sk ml-auto w-10"></span>} @else {{{ value(row, col.key) }}}
          </td>
          }
          <td class="text-center">
            @if (row.post.adCode; as code) {
            <button type="button" class="rp-copy" data-tip="Copy Ad-Code"
              [attr.aria-label]="'Copy ad code for ' + (row.creator?.name ?? 'this creator')"
              (click)="onCopyAdCode($event, code)" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
              <mba-icon name="copy" size="size-3.5" />
            </button>
            } @else {
            <span class="mo-sub" aria-label="No ad code">–</span>
            }
          </td>
          <td>
            @if (statsLoading()) {
            <span class="rp-sk w-12"></span>
            } @else if (row.stats?.source) {
            <span class="rp-src" [class.us]="row.stats?.source === 'ultra'" [class.ss]="row.stats?.source === 'super'"
              [attr.title]="sourceTitle(row)" [attr.aria-label]="sourceTitle(row)" role="img">
              {{ row.stats?.source === 'ultra' ? 'Ultra' : 'Super' }}
            </span>
            } @else {
            <span class="rp-src none" [attr.title]="sourceTitle(row)" [attr.aria-label]="sourceTitle(row)" role="img">None</span>
            }
          </td>
          <td class="chev"><mba-icon name="chevron-right" size="size-4 ml-auto block" /></td>
        </tr>
        }

        @if (!rows().length && filtered()) {
        <tr>
          <td [attr.colspan]="colSpan">
            <div class="rp-none">
              <b>No posts match</b>
              <span class="mo-sub">Try a different creator name or platform.</span>
              <button type="button" class="rp-btn" (click)="clearFilters.emit()">Clear filters</button>
            </div>
          </td>
        </tr>
        }

        @if (notPosted().length) {
        <tr class="rp-ghd"><td [attr.colspan]="colSpan"><span class="mo-k">Not posted yet · {{ notPosted().length }}</span></td></tr>
        @for (np of notPosted(); track np.applicationId + np.socialChannel + np.deliverableLabel) {
        <tr class="ghost">
          <td>
            <div class="mm-post">
              <span class="mm-mini"><mba-icon name="clock" size="size-3.5" />
                @if (np.platform) {<span class="mo-logo"><img [src]="logos[np.platform]" alt="" /></span>}
              </span>
              <span class="flex min-w-0 flex-col">
                <b>{{ creatorName(np.creatorId) }}</b>
                <span class="mo-sub">{{ np.deliverableLabel }} · {{ channelName(np.socialChannel) }}</span>
              </span>
            </div>
          </td>
          <td>Not posted</td>
          <td [attr.colspan]="9">{{ notPostedStatus(np) }}</td>
          <td>
            @if (np.videoApproved) {
            @if (nudgeBlockedUntil(np); as blocked) {
            <span class="mo-sub">{{ blocked }}</span>
            } @else {
            <button type="button" class="rp-btn sm" [disabled]="nudging() === np.applicationId"
              [attr.aria-label]="'Remind ' + creatorName(np.creatorId) + ' to post'" (click)="nudge.emit(np)">
              <mba-icon name="bell" size="size-3.5" />{{ nudging() === np.applicationId ? 'Sending…' : 'Nudge' }}
            </button>
            }
            }
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
  </div>
</div>
